// extracted by mini-css-extract-plugin
module.exports = {"Title":"ConfirmChange_Title__i5_uQ","Card":"ConfirmChange_Card__3w4vh","ChangeDateButton":"ConfirmChange_ChangeDateButton__1nFoJ"};